import { render, staticRenderFns } from "./PostbackLogs.vue?vue&type=template&id=5ae0f6a2&scoped=true"
import script from "./PostbackLogs.vue?vue&type=script&lang=js"
export * from "./PostbackLogs.vue?vue&type=script&lang=js"
import style0 from "./PostbackLogs.vue?vue&type=style&index=0&id=5ae0f6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae0f6a2",
  null
  
)

export default component.exports